module.exports = __webpack_public_path__ + "img/reportsResults.fd94d1c2.png";